import type { AskRedoUIMessage } from "../types";

/**
 * Pull the plain-text body + image URLs out of a user UIMessage to
 * forward to Intercom via `sendEscalationMessage`.
 *
 * Why only images: Intercom's `postUserReply` only accepts the
 * subset of attachment URLs the chat uploader produces. Files /
 * videos uploaded via Ask Redo go through the same uploader so
 * checking `mediaType` is the seam — broaden later if Intercom
 * grows to handle more types.
 */
export function extractUserReplyPayload(message: AskRedoUIMessage): {
  text: string;
  attachmentUrls: string[];
} {
  if (message.role !== "user") {
    return { text: "", attachmentUrls: [] };
  }

  const texts: string[] = [];
  const attachmentUrls: string[] = [];

  for (const part of message.parts) {
    if (part.type === "text" && part.text.length > 0) {
      texts.push(part.text);
    } else if (
      part.type === "file" &&
      typeof part.url === "string" &&
      part.url.length > 0
    ) {
      attachmentUrls.push(part.url);
    }
  }

  return { text: texts.join("\n").trim(), attachmentUrls };
}
